import { useGoalContext } from '@/store/contexts/GoalContext'

/**
 * Goal 관련 Custom Hook
 * GoalContext를 래핑하여 사용하기 편리하게 만듦
 */
export function useGoal() {
  return useGoalContext()
}

